"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/MembershipPodsComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MembershipItemPodComponent = /** @class */ (function (_super) {
    __extends(MembershipItemPodComponent, _super);
    function MembershipItemPodComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MembershipItemPodComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "col-sm-12 col-md-6 col-lg-4 flex-column d-flex align-items-stretch pb-20" },
            react_1.default.createElement("article", { className: "pod membership-type-pods card matchHeightClass", id: "membershipPod_" + this.props.UniqueKey },
                react_1.default.createElement("div", { className: "card-body" },
                    react_1.default.createElement("h2", { className: "card-title" }, this.props.Title),
                    react_1.default.createElement("p", { className: "card-text" }, this.props.ApplicationSubscription),
                    react_1.default.createElement("p", { className: "card-text" }, this.props.MultiGroupSubscription),
                    react_1.default.createElement("a", { href: this.props.LinkToApplyUrl, className: "btn btn-primary btn-lg" }, "Apply")),
                react_1.default.createElement("div", { className: "card-footer" },
                    react_1.default.createElement("p", { className: "card-footer-text" }, this.props.ApplicationFee)))));
    };
    return MembershipItemPodComponent;
}(react_1.Component));
exports.default = MembershipItemPodComponent;
